export const INTERN_STATUSES = {
  pending_video: { label: 'Pending Video', color: '#ed6c02' },
  pending_assessment: { label: 'Pending Assessment', color: '#2563eb' },
  pending_referral: { label: 'Pending Referral', color: '#7c3aed' },
  pending_review: { label: 'Pending Review', color: '#d97706' },
  approved: { label: 'Approved', color: '#16a34a' },
  rejected: { label: 'Rejected', color: '#dc2626' },
  suspended: { label: 'Suspended', color: '#6b7280' },
};

export const BOOKING_STATUSES = {
  pending: { label: 'Pending', color: '#ed6c02' },
  confirmed: { label: 'Confirmed', color: '#16a34a' },
  in_progress: { label: 'In Progress', color: '#2563eb' },
  pending_report: { label: 'Awaiting Mentor Review', color: '#7c3aed' },
  needs_revision: { label: 'Revision Requested', color: '#dc2626' },
  completed: { label: 'Completed', color: '#0d9488' },
  cancelled: { label: 'Cancelled', color: '#dc2626' },
  intern_no_show: { label: 'Intern No-Show', color: '#dc2626' },
  client_no_show: { label: 'Client No-Show', color: '#dc2626' },
  expired: { label: 'Expired', color: '#6b7280' },
};

export const ASSESSMENT_STATUSES = {
  scheduled: { label: 'Scheduled', color: '#2563eb' },
  in_progress: { label: 'In Progress', color: '#ed6c02' },
  pending_review: { label: 'Pending Review', color: '#d97706' },
  under_review: { label: 'Under Review', color: '#7c3aed' },
  approved: { label: 'Approved', color: '#16a34a' },
  revision_needed: { label: 'Revision Needed', color: '#dc2626' },
  completed: { label: 'Completed', color: '#0d9488' },
};

export const PAYMENT_STATUSES = {
  pending: { label: 'Pending', color: '#ed6c02' },
  paid: { label: 'Paid', color: '#16a34a' },
  processing: { label: 'Processing', color: '#2563eb' },
  failed: { label: 'Failed', color: '#dc2626' },
};

export const SIDEBAR_WIDTH = 260;

export const COGNITO_CONFIG = {
  UserPoolId: 'us-east-1_BgiyvRzCN',
  ClientId: '6jh0pek0fjvel7fdlhrimkm9mn',
};

export const INTERN_GROUP = 'intern';

// Earnings split per assessment (CWC absorbs Stripe fees)
export const INTERN_PAY_HOME = 140;
export const INTERN_PAY_BUSINESS = 240;
// Legacy alias for code that doesn't differentiate.
export const INTERN_PAY_PER_ASSESSMENT = INTERN_PAY_HOME;
// One-time bonus per UNIQUE referred client.
export const REFERRAL_BONUS_PER_ASSESSMENT = 10;

// Days of week and time slots for availability calendar
export const DAYS_OF_WEEK = [
  { key: 'mon', label: 'Monday' },
  { key: 'tue', label: 'Tuesday' },
  { key: 'wed', label: 'Wednesday' },
  { key: 'thu', label: 'Thursday' },
  { key: 'fri', label: 'Friday' },
  { key: 'sat', label: 'Saturday' },
  { key: 'sun', label: 'Sunday' },
];

export const TIME_SLOTS = [
  { key: 'morning', label: 'Morning', range: '9 AM - 12 PM' },
  { key: 'afternoon', label: 'Afternoon', range: '12 PM - 4 PM' },
  { key: 'evening', label: 'Evening', range: '4 PM - 8 PM' },
];
